import { cn } from '../lib/cn.ts'

interface ProgressProps {
  value: number
  className?: string
  barClassName?: string
  trackClassName?: string
  label?: string
}

export function Progress({ value, className, barClassName, trackClassName, label }: ProgressProps) {
  const clamped = Math.max(0, Math.min(100, value))

  return (
    <div className={cn('flex items-center gap-2.5', className)}>
      <span
        role="progressbar"
        aria-valuenow={clamped}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label={label}
        className={cn('block h-1.5 flex-1 overflow-hidden rounded-full bg-line', trackClassName)}
      >
        <span
          className={cn('block h-full rounded-full bg-brand-mid transition-[width] duration-300', barClassName)}
          style={{ width: `${clamped}%` }}
        />
      </span>
    </div>
  )
}
